import React from 'react';
import { canNavTOScoreCard } from '@Service/authentication';
import { fetchMetaDataPromise } from '@Actions/documentActions';
import { getScoreCardPromise } from '@Actions/scoreCardActions';
import store from '@Store';
import { fetchLoginData } from '@Actions/authentication';
import { getClauseLibraryPromise, getClauseLibraryByIdPromise } from '@Actions/clauseActions';
import { isAfterOrEqual } from '@Utils/versionUtils';
import { STORAGE_TYPE, getFromStorage } from '@Service/storageService';
import { DocumentStatus } from '@Constants/status';
import MiddleInfoMessage from '@Components/UI/MiddleInfoMessage';
import { InnerFrameWrapper } from './LoadingContainer.style';
import { NOTIFICATION_HANDLER } from '@Constants/types';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import { defaultDigiApp } from '@Utils/commonUtils';
import { calculateOverflow } from '@Utils/commonUtils';
class LoadingContainer extends React.Component {
    navigateToLandingPage(enabled, history, retry) {
        const rootReducer = store.getState();
        const { scoreCard } = rootReducer;
        const { digAppsPendingStatus } = scoreCard;

        /* We need to wait for all the digi app endpoint calls to return the status of their active rules before
           we navigate to the appropriate landing page.  If all the active digApps have no active rules then
           the scorecard page is an inappropriate landing page */
        if (digAppsPendingStatus.length === 0) {
            if (enabled && canNavTOScoreCard()) {
                history.push('/scorecards');
                calculateOverflow('scorecards');
            } else {
                history.push('/labels');
                calculateOverflow('labels');
            }
            return;
        }

        /* Still waiting for all the digiApp endpoint calls to return */
        retry += 1;
        if (retry < 100) {
            setTimeout(() => this.navigateToLandingPage(enabled, history, retry), 50);
            return;
        }

        /* Dont loop forever.  100 retries should be long enough */
        history.push('/labels');
        calculateOverflow('labels');
    }

    getDigAppName() {
        const rootReducer = store.getState();
        const { scoreCard, auth } = rootReducer;
        const { digAppsFilteredArray } = scoreCard;
        const { version } = auth;

        let digApp = '';
        if (digAppsFilteredArray.length) {
            if (isAfterOrEqual('7.5.0', version)) {
                // get the digAppName from the document's properties from the previous submission (if any)
                const digAppIdPreviouslySubmittedOn = getFromStorage(
                    'digAppId',
                    STORAGE_TYPE.PROPERTY_BAG
                );
                if (digAppIdPreviouslySubmittedOn) {
                    digApp = digAppIdPreviouslySubmittedOn;
                }
            } else if (isAfterOrEqual('7.2.1', version)) {
                digApp = defaultDigiApp(digAppsFilteredArray);
            }
        }
        return digApp;
    }

    dataLoad() {
        const { history } = this.props;
        const rootReducer = store.getState();
        const { auth } = rootReducer;
        const { user } = auth;
        const { permissions = [] } = user;

        // isAuthenticated has toggled from false to true
        // now load the clause library
        getClauseLibraryPromise()
            .then(clauseLibraryId => {
                getClauseLibraryByIdPromise(clauseLibraryId)
                    .then(() => {
                        // now load the labels metadata and scorecard data
                        const digAppNameOrId = this.getDigAppName();
                        const { scoreCard } = rootReducer;
                        const { version, scorecardPollingEnabled, enabled } = scoreCard;
                        const { version: sealVersion } = auth;

                        const docStatus = getFromStorage(
                            'sealAtnDocumentStatus',
                            STORAGE_TYPE.PROPERTY_BAG
                        );
                        const documentId = getFromStorage(
                            'sealAtnDocumentId',
                            STORAGE_TYPE.PROPERTY_BAG
                        );
                        const sealUrlSubmittedOn = getFromStorage(
                            'sealUrl',
                            STORAGE_TYPE.PROPERTY_BAG
                        );
                        const selectedSystemUrl = getFromStorage(
                            'seal_url',
                            STORAGE_TYPE.LOCAL_STORAGE
                        );

                        addLog(
                            LOG_TYPE.INFO,
                            'LoadingContainer.dataLoad',
                            `sealAtnDocumentStatus = ${docStatus}`
                        );
                        addLog(
                            LOG_TYPE.INFO,
                            'LoadingContainer.dataLoad',
                            `sealAtnDocumentId = ${documentId}`
                        );
                        addLog(
                            LOG_TYPE.INFO,
                            'LoadingContainer.dataLoad',
                            `sealUrlSubmittedOn = ${sealUrlSubmittedOn}`
                        );
                        addLog(
                            LOG_TYPE.INFO,
                            'LoadingContainer.dataLoad',
                            `selectedSystemUrl = ${selectedSystemUrl}`
                        );

                        // start the fade-out of the "Loading..." message
                        this.setState({
                            hideMessage: true
                        });

                        // whilst the digApp service might be enabled, we may not have any active
                        // digApps (currently, or ever), so we need to call refreshMetaData to ensure
                        // that we have label data when the user logs-in
                        // if (permissions.length) refreshMetaData();
                        if (permissions.length) {
                            // we have permissions, so fetch the metadata for this document (if any)
                            fetchMetaDataPromise()
                                .then(() => {
                                    if (
                                        docStatus !== DocumentStatus.NOT_SUBMITTED &&
                                        sealUrlSubmittedOn === selectedSystemUrl
                                    ) {
                                        // we have a scorecard, so lets fetch this data before we login
                                        getScoreCardPromise(
                                            digAppNameOrId,
                                            version,
                                            documentId,
                                            sealVersion,
                                            scorecardPollingEnabled
                                        ).then(() => {
                                            // scorecard data loaded, now navigate to landing page
                                            this.navigateToLandingPage(enabled, history, 0);
                                        });
                                    } else {
                                        // no scorecard data, so just login
                                        setTimeout(
                                            () => this.navigateToLandingPage(enabled, history, 0),
                                            2000
                                        );
                                    }
                                })
                                .catch(err => {
                                    addLog(LOG_TYPE.ERROR, 'LoadingContainer.dataLoad', err);

                                    store.dispatch({
                                        type: NOTIFICATION_HANDLER.ERROR,
                                        payload: err
                                    });
                                });
                        } else {
                            // no permissions
                            if (
                                docStatus !== DocumentStatus.NOT_SUBMITTED &&
                                sealUrlSubmittedOn === selectedSystemUrl
                            ) {
                                // we have a scorecard, so lets fetch this data before we login
                                getScoreCardPromise(
                                    digAppNameOrId,
                                    version,
                                    documentId,
                                    sealVersion,
                                    scorecardPollingEnabled
                                ).then(() => {
                                    // scorecard data loaded, now navigate to landing page
                                    this.navigateToLandingPage(enabled, history, 0);
                                });
                            } else {
                                // no scorecard data, so just login
                                setTimeout(
                                    () => this.navigateToLandingPage(enabled, history, 0),
                                    2000
                                );
                            }
                        }
                    })
                    .catch(err => {
                        addLog(LOG_TYPE.ERROR, 'LoadingContainer.dataLoad', err);

                        store.dispatch({
                            type: NOTIFICATION_HANDLER.ERROR,
                            payload: err
                        });
                    });
            })
            .catch(err => {
                addLog(LOG_TYPE.ERROR, 'LoadingContainer.dataLoad', err);

                if (err.response.status === 403) {
                    const digAppNameOrId = this.getDigAppName();
                    const { scoreCard } = rootReducer;
                    const { version, scorecardPollingEnabled, enabled } = scoreCard;
                    const { version: sealVersion } = auth;

                    const docStatus = getFromStorage(
                        'sealAtnDocumentStatus',
                        STORAGE_TYPE.PROPERTY_BAG
                    );
                    const documentId = getFromStorage(
                        'sealAtnDocumentId',
                        STORAGE_TYPE.PROPERTY_BAG
                    );
                    const sealUrlSubmittedOn = getFromStorage('sealUrl', STORAGE_TYPE.PROPERTY_BAG);
                    const selectedSystemUrl = getFromStorage(
                        'seal_url',
                        STORAGE_TYPE.LOCAL_STORAGE
                    );

                    addLog(
                        LOG_TYPE.INFO,
                        'LoadingContainer.dataLoad',
                        `sealAtnDocumentStatus = ${docStatus}`
                    );
                    addLog(
                        LOG_TYPE.INFO,
                        'LoadingContainer.dataLoad',
                        `sealAtnDocumentId = ${documentId}`
                    );
                    addLog(
                        LOG_TYPE.INFO,
                        'LoadingContainer.dataLoad',
                        `sealUrlSubmittedOn = ${sealUrlSubmittedOn}`
                    );
                    addLog(
                        LOG_TYPE.INFO,
                        'LoadingContainer.dataLoad',
                        `selectedSystemUrl = ${selectedSystemUrl}`
                    );

                    // start the fade-out of the "Loading..." message
                    this.setState({
                        hideMessage: true
                    });

                    // whilst the digApp service might be enabled, we may not have any active
                    // digApps (currently, or ever), so we need to call refreshMetaData to ensure
                    // that we have label data when the user logs-in
                    // if (permissions.length) refreshMetaData();
                    if (permissions.length) {
                        // we have permissions, so fetch the metadata for this document (if any)
                        fetchMetaDataPromise()
                            .then(() => {
                                if (
                                    docStatus !== DocumentStatus.NOT_SUBMITTED &&
                                    sealUrlSubmittedOn === selectedSystemUrl
                                ) {
                                    // we have a scorecard, so lets fetch this data before we login
                                    getScoreCardPromise(
                                        digAppNameOrId,
                                        version,
                                        documentId,
                                        sealVersion,
                                        scorecardPollingEnabled
                                    ).then(() => {
                                        // scorecard data loaded, now navigate to landing page
                                        this.navigateToLandingPage(enabled, history, 0);
                                    });
                                } else {
                                    // no scorecard data, so just login
                                    setTimeout(
                                        () => this.navigateToLandingPage(enabled, history, 0),
                                        2000
                                    );
                                }
                            })
                            .catch(err2 => {
                                addLog(LOG_TYPE.ERROR, 'LoadingContainer.dataLoad', err);

                                store.dispatch({
                                    type: NOTIFICATION_HANDLER.ERROR,
                                    payload: err2
                                });
                            });
                    } else {
                        // no permissions
                        if (
                            docStatus !== DocumentStatus.NOT_SUBMITTED &&
                            sealUrlSubmittedOn === selectedSystemUrl
                        ) {
                            // we have a scorecard, so lets fetch this data before we login
                            getScoreCardPromise(
                                digAppNameOrId,
                                version,
                                documentId,
                                sealVersion,
                                scorecardPollingEnabled
                            ).then(() => {
                                // scorecard data loaded, now navigate to landing page
                                this.navigateToLandingPage(enabled, history, 0);
                            });
                        } else {
                            // no scorecard data, so just login
                            setTimeout(() => this.navigateToLandingPage(enabled, history, 0), 2000);
                        }
                    }
                } else {
                    store.dispatch({
                        type: NOTIFICATION_HANDLER.ERROR,
                        payload: err
                    });
                }
            });
        return null;
    }

    checkAuthentication() {
        const rootReducer = store.getState();
        const { auth } = rootReducer;
        const { isAuthenticated } = auth;

        if (isAuthenticated) {
            this.dataLoad();
        } else {
            setTimeout(() => this.checkAuthentication(), 500);
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            hideMessage: false
        };
    }

    componentDidMount() {
        // Complete the remaining login steps
        // This will toggle isAuthenticated=true
        const rootReducer = store.getState();
        const { auth } = rootReducer;
        const { user } = auth;
        fetchLoginData(user);

        setTimeout(() => this.checkAuthentication(), 500);
    }

    render() {
        const { hideMessage } = this.state;
        return (
            <InnerFrameWrapper hideMessage={hideMessage}>
                <MiddleInfoMessage
                    className="loading-message"
                    noposition="true"
                    message="Loading..."
                />
            </InnerFrameWrapper>
        );
    }
}

export default LoadingContainer;
